export default "__VITE_ASSET__CrlA9rHS__"